/**
 * Typed, normalised access to build-time configuration. Components import
 * from here rather than reading import.meta.env directly, so there is one
 * place that knows the variable names and their defaults.
 */
export const env = {
  /** API origin without a trailing slash; '' means same-origin. */
  apiUrl: (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/, ''),
  /** The platform's domain; tenants live one label below it. */
  baseDomain: (import.meta.env.VITE_BASE_DOMAIN || 'localhost').toLowerCase().replace(/^\.+|\.+$/g, ''),
  /** Labels under the base that are the platform too (tenancy.platform_aliases): `www` by default. */
  platformAliases: (import.meta.env.VITE_PLATFORM_ALIASES || 'www')
    .split(',')
    .map((alias) => alias.trim().toLowerCase())
    .filter((alias) => alias !== ''),
  isDevelopment: import.meta.env.DEV,
} as const
